export default __webpack_public_path__ + "static/media/footer_pc.d9ff412c.png";